/**
 * 入力フォーム系で利用するバリデーションメソッド群
 * @todo 適宜追加
 */
import isEmail from "validator/lib/isEmail";

/**
 * 桁数チェック ペア
 * @param target1Size
 * @param target2Size
 * @param maxSize
 * @returns boolean「true:OK」「false:NG」
 */
export const validMaxSizeInPairs = (target1Size, target2Size, maxSize) => {
  if (target1Size > 0 && target2Size > 0) {
    if (target1Size + target2Size > maxSize - 1) {
      return false;
    }
  }
  return true;
};

/**
 * メールアドレスのバリデーション
 * @param {String} mailAddress input要素へ入力されたメールアドレス
 * @return {Boolean} 「true：バリデーションOK」「false：NG」
 */
export const mailAddressValidationCheck = (mailAddress) => {
  // 空は無視
  if (!mailAddress) return true;
  if (
    !isEmail(mailAddress, {
      allow_utf8_local_part: false,
      ignore_max_length: true,
    })
  )
    return false;

  return (
    // @より前に「!」が2つ入っていたらエラー
    !mailAddress.match(/^.*!.*!.*@.*$/) &&
    // @より前に「%」が入っていたらエラー
    !mailAddress.match(/^.*%.*@.*$/) &&
    // 先頭に「-」が入っていたらエラー
    !mailAddress.match(/^-.*@.*$/) &&
    // 先頭に「/」が入っていたらエラー
    !mailAddress.match(/^\/.*@.*$/) &&
    // 先頭に「|」が入っていたらエラー
    !mailAddress.match(/^[|].*@.*$/) &&
    // @より後に半角英数字、「.」「-」以外の文字が入っていたらエラー
    !mailAddress.match(/^.*@.*[^a-zA-Z0-9.-].*$/) &&
    // @の直後に「-」が入っていたらエラー
    !mailAddress.match(/^.*@-.*$/) &&
    // 末尾に「-」が入っていたらエラー
    !mailAddress.match(/^.*@.*-$/) &&
    // @の直後に「.」が入っていたらエラー
    !mailAddress.match(/^.*@[.].+.*$/) &&
    // @より後に「.」が連続していたらエラー
    !mailAddress.match(/^.*@.*[.][.].*$/)
  );
};
